export default __webpack_public_path__ + "static/media/pattern_O.41c55fea.png";